import Vue from 'vue'
import crmService from '@/services/crm_service'
import { langByLocale } from '@/utils'

const state = {
  schema: {
    activities: { attributes: {} },
    quotes: { attributes: {} }
  }
}

const mutations = {
  'SET_SCHEMA' (state, { mod, sch }) {
    Vue.set(state.schema, mod, sch)
  }
}

const actions = {
  getSchema ({ commit }, { mod, locale }) {
    const lang = langByLocale(locale)
    crmService.getSchema(mod, lang, sch => commit('SET_SCHEMA', { mod, sch }))
  }
}

export default {
  state,
  mutations,
  actions
}
